import { useEffect } from 'react';

import { useAppsFlyer } from '../useAppsFlyer';

export const useAppsFlyerInitialization = (isTrackingAllowed: boolean, userId?: string | null) => {
  const { initializeAppsFlyer, setCustomerUserId } = useAppsFlyer();

  useEffect(() => {
    if (!isTrackingAllowed) return;

    void initializeAppsFlyer();
  }, [initializeAppsFlyer, isTrackingAllowed]);

  useEffect(() => {
    if (!isTrackingAllowed || !userId) return;

    setCustomerUserId(userId);
  }, [userId, isTrackingAllowed, setCustomerUserId]);
};
